<form [formGroup]="addEditForm" *ngIf="addEditForm && validation" [ngClass]="{'required': !validation.code.nullable}" (ngSubmit)="saveOrUpdate(dialogBoxCertification)" RestrictFocus>
  <div class="ui-grid ui-grid-responsive ui-fluid Loyalty" >
    <div class="ui-grid-row">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.code.nullable}">{{ validation.code.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input formControlName="code" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.code"></app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !validation.description.nullable}">{{ validation.description.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input formControlName="description" pInputText />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="addEditForm" [validation]="validation.description"></app-validation-msg>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane text-center ui-helper-clearfix">
      <button  class="k-generic-btn" type="submit" pButton icon="fa fa-check" label="{{dialogBoxCertification.id ? ('common.edit' | translate) :  ('common.add' | translate) }} {{ 'certificationList.certification' | translate }}"></button>
    </div>
  </p-footer>
</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/certification/certificationForm.html